import styled from "styled-components";

export const MainContainerInstrucaoBancaria = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  margin-top: 10px;
  gap: 16px;
  width: 90vw;
`;

export const ContainerInstrucaoBancaria = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  margin: 16px 0px;
  gap: 16px;
  width: 90vw;
`;

export const ContainerButton = styled.div`
  display: flex;
  margin-left: auto;
  gap: 16px;
`;
